import { useState, useEffect } from 'react';
import { calculateDuration, isValidTimestamp } from '../utils/dateUtils';

/**
 * Хук для отображения живого времени выполнения задачи
 * @param startTime Время начала задачи в миллисекундах
 * @param endTime Время завершения задачи (если есть)
 * @param isActive Активна ли задача (статус pending)
 * @returns Строка с форматированным временем
 */
export function useLiveTimer(
  startTime: number, 
  endTime?: number, 
  isActive: boolean = false
): string {
  const [currentTime, setCurrentTime] = useState<number>(Date.now());


  useEffect(() => {
    if (!isActive || endTime) {
      return; // Не запускаем таймер для завершенных задач
    }

    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000); // Обновляем каждую секунду

    return () => clearInterval(interval);
  }, [isActive, endTime]);

  // Валидируем timestamp'ы
  const validStartTime = isValidTimestamp(startTime) ? startTime : Date.now();
  const validEndTime = endTime && isValidTimestamp(endTime) ? endTime : undefined;
  const validCurrentTime = isValidTimestamp(currentTime) ? currentTime : Date.now();

  const end = validEndTime || (isActive ? validCurrentTime : Date.now());
  const duration = end - validStartTime;
  
  const result = calculateDuration(validStartTime, end);
  
  return result;
} 